// extracted by mini-css-extract-plugin
export var logoWrapper = "Header-module--logoWrapper--Np5YQ";
export var search = "Header-module--search--Nq8+I";
export var searchResults = "Header-module--searchResults--oW5sx";
export var searchWrapper = "Header-module--searchWrapper--52XME";